import {createSlice} from "@reduxjs/toolkit"
import { add } from "date-fns"


const InitialState = {
    sale:[],
    totalSale:0,
    expense:[],
    totalExpense:0,
    customer:[],
}

export const salesSlice = createSlice({
    name:"sale",
    initialState:InitialState,
    reducers:{
        addAllsales:(state,action)=>{
            state.sale = action.payload
        },
        addExpense:(state,action)=>{
            state.expense= action.payload
        },
        addTotalExpense:(state,action)=>{
            state.totalExpense = action.payload
        },
        addsale:(state,action)=>{
            state.sale.push(action.payload)
        },
        addTotalSale:(state,action)=>{
            state.totalSale = action.payload
        },
        addCustomer:(state,action)=>{
            state.customer = action.payload
        },
        updatesale: (state, action) => {
  const updatedsale = action.payload;
  const saleIndex = state.sale.findIndex(sale => sale._id === updatedsale._id);
  if (saleIndex !== -1) {
    state.sale[saleIndex] = {
      ...state.sale[saleIndex],
      ...updatedsale
    };
  }
}
    }
})



export const {addAllsales,addsale,updatesale,addTotalSale,addExpense,addTotalExpense,addCustomer} = salesSlice.actions

export default salesSlice.reducer